"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var store_1 = require("../store/store");
exports.default = satcheljs_1.mutatorAction('setSearchTerm', function setSearchTerm(searchTerm) {
    store_1.getStore().searchTerm = searchTerm;
});
//# sourceMappingURL=setSearchTerm.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/mutators/setSearchTerm.js
// module id = 3723
// module chunks = 2